import React, { ReactNode, useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import IconButton from 'components/IconButton';

import styles from './Slider.module.scss';

interface SliderProps {
  children: ReactNode;
  scrollWidth: number;
  onNavigate?: (translateX: number) => void;
}

export const Slider: React.FC<SliderProps> = (props) => {
  const { children, scrollWidth, onNavigate } = props;
  const sliderRef = useRef<HTMLDivElement | null>(null);

  const [showPrevArrow, setShowPrevArrow] = useState<boolean>(false);
  const [showNextArrow, setShowNextArrow] = useState<boolean>(true);

  useEffect(() => {
    const handleScroll = () => {
      if (sliderRef.current) {
        const { current } = sliderRef;
        setShowPrevArrow(current.scrollLeft > 0);
        setShowNextArrow(
          current.scrollLeft + current.clientWidth < current.scrollWidth
        );
      }
    };
    handleScroll();
    sliderRef.current?.addEventListener('scroll', handleScroll);

    return () => {
      sliderRef.current?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleNavigation = (isNext: boolean) => () => {
    if (sliderRef.current) {
      const { current } = sliderRef;
      let newScrollPosition = 0;
      if (isNext) {
        const scrollAreaWdith = current.scrollWidth - current.clientWidth;
        newScrollPosition = Math.min(
          current.scrollLeft + scrollWidth,
          scrollAreaWdith
        );
      } else {
        newScrollPosition = Math.max(
          current.scrollLeft - scrollWidth,
          current.scrollLeft - current.clientWidth
        );
      }
      current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth',
      });
      onNavigate && onNavigate(newScrollPosition);
    }
  };

  return (
    <div className={styles.SliderWrapper}>
      <div className={styles.SliderContainer} ref={sliderRef}>
        {showPrevArrow && (
          <div className={styles.navigationButton}>
            <IconButton
              iconName="chevron-left"
              size={'xlarge'}
              onClick={handleNavigation(false)}
              className={styles.navigationButtonIcon}
              type="button"
            />
          </div>
        )}
        {children}
        {showNextArrow && (
          <div
            className={cn(
              styles.navigationButton,
              styles.navigationButtonRight
            )}
          >
            <IconButton
              iconName="chevron-right"
              size={'xlarge'}
              onClick={handleNavigation(true)}
              className={styles.navigationButtonIcon}
              type="button"
            />
          </div>
        )}
      </div>
    </div>
  );
};
